import React from 'react';
import styles from './enquire.module.css';

const Index = () => {
    return (
        <React.Fragment>
            <div className={`${styles['bg-light-blue']}`}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <h3 className={`${styles['third-title']}`}>Your Go-To Platform for Job Posting & Recruitment</h3>
                            <p className={`${styles['common-para']} my-3`}>
                                Supercharge your hiring process with JobzShala's cutting-edge recruitment solutions.
                                Post jobs effortlessly and attract top-tier talent.
                            </p>
                            <div className='row d-flex flex-row flex-wrap justify-content-center'>
                                <div className='col-4 col-md-4 text-center'>
                                    <div>
                                        <h4 className={`${styles['count-hd']}`}>500+</h4>
                                        <h4 className={`${styles['count-para']}`}>MNC posting <br />jobs daily</h4>
                                    </div>
                                </div>
                                <div className='col-4 col-md-4 text-center'>
                                    <div>
                                        <h4 className={`${styles['count-hd']}`}>2K+</h4>
                                        <h4 className={`${styles['count-para']}`}>Roles and <br />Industries</h4>
                                    </div>
                                </div>
                                <div className='col-4 col-md-4 text-center'>
                                    <div>
                                        <h4 className={`${styles['count-hd']}`}>7K+</h4>
                                        <h4 className={`${styles['count-para']}`}>Placed <br />Candidates</h4>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='col-md-6'>
                            {[{
                                icon: 'eduicon.svg',
                                title: 'Fast Job Posting',
                                description: 'Post job openings in under 2 minutes with ease.',
                            }, {
                                icon: 'edujobicon.svg',
                                title: 'Unlimited Applications',
                                description: 'Receive a flood of applications from qualified candidates.',
                            }, {
                                icon: 'edubuildicon.svg',
                                title: 'Diverse Candidate Pool',
                                description: 'Attract a broad and enthusiastic audience.',
                            }].map((item, index) => (
                                <div className='row mt-4 align-items-start mb-3' key={index}>
                                    <div className='col-auto'>
                                        <div className={`${styles['icon-box']}`}>
                                            <img src={`https://cdn.jobzseed.com/employer/images/homepage/${item.icon}`} alt={item.title} />
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <h5 className={`${styles['title-hd']}`}>{item.title}</h5>
                                        <p className={`${styles['title-para']}`}>{item.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 my-5 text-center'>
                        <h4 className={`${styles['hire-title']}`}>Simplify Your Hiring Process</h4>
                    </div>
                </div>
                {[{
                    step: '1',
                    title: 'Access Top Talent',
                    description: 'Post jobs in minutes and reach the right candidates instantly.',
                    image: 'talent.svg',
                }, {
                    step: '2',
                    title: 'Smart Candidate Screening',
                    description: 'AI-driven filtering ensures you connect with the most suitable applicants.',
                    image: 'screening-candidates.svg',
                }, {
                    step: '3',
                    title: 'Advanced Hiring Tools',
                    description: 'Leverage chat, video calls, and interview scheduling to streamline hiring.',
                    image: 'smarttools.svg',
                }].map((item, index) => (
                    <div className={`row mb-4 ${index % 2 !== 0 ? styles['bgct-light'] : ''} py-4`} key={index}>
                        <div className={`col-md-6 ${index % 2 === 0 ? 'order-md-1' : 'order-md-2'} py-3 d-flex flex-column justify-content-center`}>
                            <div className='d-flex align-items-center'>
                                <span className={`${styles['number-txt']}`}>{item.step}</span>
                                <span className={`${styles['number-title']}`}>{item.title}</span>
                            </div>
                            <p className={`${styles['number-para']} mt-3`}>{item.description}</p>
                        </div>
                        <div className={`col-md-6 ${index % 2 === 0 ? 'order-md-2' : 'order-md-1'} py-3`}>
                            <img className='img-fluid' src={`https://cdn.jobzseed.com/employer/images/homepage/${item.image}`} alt={item.title} />
                        </div>
                    </div>
                ))}
            </div>
        </React.Fragment>
    );
};

export default Index;